export default __webpack_public_path__ + "media/images/logo_full-478256b5d5b9a56e4d8ee2eff8420f6a.svg";